import React from "react";
import {useTranslation} from "react-i18next";
import { reachGoal } from 'utils/metrica';

import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import './notification-text.scss'

type Props = {
    onLogin(): void;
}

const NotificationText = ({onLogin}: Props) => {

  const { t } = useTranslation()

  return <div className='demo-notification__notification'>
    <div className='cabinet-modal'>
      <Typography variant='h5' sx={{ padding: '24px', fontWeight: '700' }}>
        {t('common__message__welcomeToTheDemoVersion')}
      </Typography>
      <hr className='cabinet-modal__divider'/>
      <div className='cabinet-modal__text'>
        <Typography
          component='div'
          variant='body1'
          sx={{ lineHeight: 1.5, fontWeight: 400, letterSpacing: '0.15px' }}
        >
          {t('common__message__demoVersion__tariffsAndRatesInfo')}
          {' '}
          {t('common__message__demoVersion__calculationsInfo')}
          {' '}
          {t('common__message__demoVersion__calculatorFunctionalityInfo')}
        </Typography>
        <Typography component='div' className='cabinet-modal__list-title'>
          {t('common__message__demoVersion__notConnected')}
        </Typography>
        <ul className='cabinet-modal__list'>
          <li className='cabinet-modal__list-item'>
            {t('common__message__demoVersion__pickupAndLastMile')}
          </li>
          <li className='cabinet-modal__list-item'>
            {t('common__message__demoVersion__lclCalculation')}
          </li>
          <li className='cabinet-modal__list-item'>
            {t('common__message__demoVersion__recyclingFeeCalculation')}
          </li>
          <li className='cabinet-modal__list-item'>
            {t('common__message__demoVersion__licensingInfo')}
          </li>
          <li className='cabinet-modal__list-item'>
            {t('common__message__demoVersion__counterpartyServices')}
          </li>
        </ul>
        <Typography component='div' className='cabinet-modal__list-title'>
          {t('common__message__demoVersion__limited')}
        </Typography>
        <ul className='cabinet-modal__list'>
          <li className='cabinet-modal__list-item'>
            {t('common__message__demoVersion__aiAssistantRequests')}
          </li>
          <li className='cabinet-modal__list-item'>
            {t('common__message__demoVersion__incotermsConditions')}
          </li>
          <li className='cabinet-modal__list-item'>
            {t('common__message__demoVersion__deliveryRoutesAndCities')}
          </li>
        </ul>
        <hr className='cabinet-modal__divider cabinet-modal__divider_bottom'/>
        <Button
          variant='contained'
          fullWidth
          className='cabinet-modal__button'
          onClick={() => {
            reachGoal({ goal: 'TARGET_NAME' });
            onLogin();
          }}
          sx={{
            marginTop: 3,
          }}
        >
          {t('actions__text__iUnderstand')}</Button>
      </div>
    </div>
  </div>
};

export default NotificationText
